import React, { useRef } from 'react';
import '../../styles/skills.css';
import htmlImg from '../../images/html.png';
import cssImg from '../../images/CSS-Logo.png';
import javascriptImg from '../../images/js.png';
import bootstrapImg from '../../images/bootstrap.png';
import reactImg from '../../images/react.png';
import muiImg from '../../images/mui.png';
import reduxImg from '../../images/redux.svg';
import firebaseImg from '../../images/firebase.png';
import figmaImg from '../../images/figma.png';
import { useSelector } from 'react-redux';
import { PageHeading, PageLine } from '../../componetns';
const SkillsSlider = () => {
    const { isDark } = useSelector((state) => state.useReducer);
    const slideRef = useRef(null);
    const slideData = [
        { src: htmlImg, alt: 'html' },
        { src: cssImg, alt: 'css' },
        { src: bootstrapImg, alt: 'bootstrapImg' },
        { src: javascriptImg, alt: 'js' },
        { src: firebaseImg, alt: 'firebaseImg' },
        { src: figmaImg, alt: 'figmaImg' },
    ];

    const handleMouseEnter = () => {
        slideRef.current.style.animationPlayState = 'paused';
    };

    const handleMouseLeave = () => {
        slideRef.current.style.animationPlayState = 'running';
    };

    return (
        <div className='skill-main' style={{ backgroundColor: `${isDark ? "#070F2B" : "#fff"}` }} name="skill">
            <PageLine />
            <PageHeading heading="My Skills" />
            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <div className="slider" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                            <div className="slide-track" ref={slideRef}>
                                {slideData.map((slide, index) => (
                                    <div key={index} className="slide">
                                        <img src={slide.src} alt={slide.alt} className='slider-img' style={{ boxShadow:  "#3F51B5 0px 1px 10px"  }} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkillsSlider;
